import { combineReducers } from '@ngrx/store';
import * as fromMltOrdersConfirm from './order.reducer';

export interface MltOrdersConfirmState {
  mltOrdersConfirmStateState: fromMltOrdersConfirm.MltOrdersConfirmState;
}

export const reducers = combineReducers({
  mltOrdersConfirmStateState: fromMltOrdersConfirm.orderReducer,
});
